import request from "@/utils/request";

// 获取订单列表
export function getJcOrderList(params) {
    return request({
        url: "/miniapp/payment/orders",
        method: "get",
        params
    });
}